import { z } from 'zod';

export const healthCheckStatusSchema = z.enum(['ok', 'error']);

export const healthResponseSchema = z.object({
  status: healthCheckStatusSchema,
  version: z.string(),
  checks: z.record(z.string(), healthCheckStatusSchema),
});

export type HealthResponse = z.infer<typeof healthResponseSchema>;
